import { render, staticRenderFns } from "./SavedFilters.vue?vue&type=template&id=64b11a42&scoped=true"
import script from "./SavedFilters.vue?vue&type=script&lang=js"
export * from "./SavedFilters.vue?vue&type=script&lang=js"
import style0 from "./SavedFilters.vue?vue&type=style&index=0&id=64b11a42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b11a42",
  null
  
)

export default component.exports